module.exports = __webpack_public_path__ + "static/media/TommyHood.7a1a13c5.glb";